import { isString } from 'lodash-es';

import logger from '../logger';
import { LOGGER_SPACIAL_SYMBOL } from '../config';
import ToastV2 from '@shared/components/base/BaseToast';

/**
 * 全局错误监听
 * @param e
 */
export const handleOnError: OnErrorEventHandlerNonNull = (e) => {
	if (isString(e)) return;

	logger.error(LOGGER_SPACIAL_SYMBOL.GLOBAL, 'NORMAL_ERROR', e);
};

/**
 * 为 handleOnError 兜底，捕获异步代码、语法、静态资源加载等错误
 * @param e
 */
export const handleOnOtherError = (e: ErrorEvent) => {
	if (
		e.message.includes('Failed to fetch dynamically imported module') ||
		e.message.includes('Unable to preload CSS')
	) {
		ToastV2.error('Module loading failed, please check your network or try again later.');
	}

	logger.error(LOGGER_SPACIAL_SYMBOL.GLOBAL, 'OTHER_ERROR', e);
};
